<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12" lg="7">
                <b-card>
                    <div class="d-flex justify-content-between">
                        <h5><i class="fa fa-fw fa-cogs mr-2" />Engine Status</h5>
                        <div class="text-right">
                            <b-btn size="sm" class="mr-2" variant="primary" @click="getEnginePerTipe">
                                Per Tipe
                            </b-btn>
                            <b-btn size="sm" variant="primary" :disabled="isGettingStatusCount" @click="getStatusCount">
                                <i class="fa fa-refresh" />
                            </b-btn>
                        </div>
                    </div>
                    <hr class="my-2" />
                    <div class="brand-card-body" style="padding: 0">
                        <div v-for="item in statusCount" v-bind:key="item.name">
                            <div v-if="item.name == 'REPAIR'" class="text-value">{{ item.id }} ({{ wspbCount }})</div>
                            <div v-else class="text-value">{{ item.id }}</div>
                            <div v-if="item.name == 'REPAIR'" class="text-uppercase text-muted small">{{ item.name }} (w/ SPB)</div>
                            <div v-else class="text-uppercase text-muted small">{{ item.name }}</div>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col sm="12" lg="5">
                <b-card>
                    <div class="d-flex justify-content-between">
                        <h5><i class="fa fa-fw fa-calendar mr-2" />Top Up & Service</h5>
                        <div class="text-right">
                            <b-btn size="sm" variant="primary" :disabled="isGettingTopupCount" @click="getTopupCount">
                                <i class="fa fa-refresh" />
                            </b-btn>
                        </div>
                    </div>
                    <hr class="my-2" />
                    <div class="brand-card-body" style="padding: 0">
                        <div>
                            <div class="text-value">{{ topupService.topup }}</div>
                            <div class="text-uppercase text-muted small">TOP-UP</div>
                        </div>
                        <div>
                            <div class="text-value">{{ topupService.service }}</div>
                            <div class="text-uppercase text-muted small">SERVICE</div>
                        </div>
                        <div>
                            <div class="text-value">{{ topupService.over }}</div>
                            <div class="text-uppercase text-muted small">OVER TOP-UP</div>
                        </div>
                        <div>
                            <div class="text-value">{{ topupService.returnOli }}</div>
                            <div class="text-uppercase text-muted small">RETURN OLI</div>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-modal id="modal-engine-types" title="Jumlah Engine per Tipe" size="lg" centered no-close-on-backdrop hide-footer>
            <div v-if="isRetrievingEngineTypes" class="text-center">
                <b-spinner class="loading-spinner" variant="dark"></b-spinner>
                <div class="mt-2">Mohon menunggu...</div>
            </div>
            <div v-else>
                <b-table bordered hover show-empty
                    :items="engineTypes"
                    :fields="fields"
                    responsive class="mb-3"
                />
                <div class="text-muted small mb-3">
                    Angka didalam kurung untuk REPAIR adalah jumlah unit Repair yang memiliki SPB pending.
                </div>
            </div>
        </b-modal>
        <DashboardEngine />
    </div>
</template>

<script>
import DashboardEngine from './DashboardEngine'

export default {
    name: 'dashboard',
    components: { DashboardEngine },
    data() {
        return {

            statusCount: [],
            wspbCount: 0,

            status: {
                active: "...",
                ready: "...",
                install: "...",
                repair: "...",
                retur: "...",
                lainnya: "..."
            },

            topupService: {
                topup: "...",
                service: "...",
                over: "...",
                returnOli: "..."
            },

            isGettingStatusCount: false,
            isGettingTopupCount: false,
            isRetrievingEngineTypes: false,

            engineTypes: [],
            fields: [
                { key: "name", label: "Nama Tipe" },
                { key: "active", label: "Installed" },
                { key: "ready", label: "Ready Line" },
                { key: "install", label: "Shipment" },
                { key: "repair", label: "Repair" },
                { key: "retur", label: "Retur" },
                { key: "lainnya", label: "Lainnya" },
                { key: "total", label: "Total" },
            ],

        }
    },
    methods: {

        getStatusCount() {

            let comps = ["ready", "active", "repair", "install", "retur", "lainnya"]

            this.isGettingStatusCount = true
            comps.forEach(it => { this.status[it] = "..." })

            this.$axios.get("dashboard/engine").then(res => {

                let data = res.data
                // comps.forEach(it => { this.status[it] = data[it] })

                this.statusCount = res.data.detail
                this.wspbCount = res.data.wspbCount

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isGettingStatusCount = false })

        },

        getTopupCount() {

            let comps = ["topup", "service", "over", "returnOli"]

            this.isGettingTopupCount = true
            comps.forEach(it => { this.topupService[it] = "..." })

            this.$axios.get("dashboard/topup-service").then(res => {

                let data = res.data
                comps.forEach(it => { this.topupService[it] = data[it] })

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isGettingTopupCount = false })

        },

        getEnginePerTipe() {

            this.isRetrievingEngineTypes = true
            this.$bvModal.show("modal-engine-types")

            this.$axios.get("dashboard/engine/types").then(res => {

                let data = res.data

                // let names = ["150 KVA", "250 KVA", "338 KVA"]
                // for(var i = 0; i < 3; i++) {
                //     data[i].name = names[i]
                // }

                let datahold = []
                data.forEach(it => {
                    it.repair = `${it.repair} (${it.pendingSpb})`
                    datahold.push(it)
                })

                this.engineTypes = datahold

            })
            .catch(error => {
                this.$bvModal.hide("modal-engine-types")
                this.$helper.parseError(this, error)
            })
            .finally(() => { this.isRetrievingEngineTypes = false })

        },



    },
    created() {

        this.getStatusCount()
        this.getTopupCount()

    }
}
</script>
